module.exports = __webpack_public_path__ + "img/Mail.0a11fc43.svg";